var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonIdealInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "url(#paint0_radial_6075_30498)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1055 58.8389L10.102 60.0578L7.07617 60.0743L7.07948 58.8556L10.1055 58.8389Z",
    fill: "#C8CDD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1162 60.5771L13.1129 61.7961L10.082 61.8099L10.0855 60.591L13.1162 60.5771Z",
    fill: "#C8CDD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.126 62.3125L16.1225 63.5312L13.0918 63.5451L13.0953 62.3261L16.126 62.3125Z",
    fill: "#C8CDD3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1318 64.0508L19.1285 65.2697L16.0977 65.2833L16.1012 64.0644L19.1318 64.0508Z",
    fill: "#C8CDD3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1416 65.7871L22.1381 67.006L19.1074 67.0197L19.1109 65.8009L22.1416 65.7871Z",
    fill: "#C8CDD3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1476 67.5215L25.1441 68.7402L22.1133 68.754L22.1168 67.5353L25.1476 67.5215Z",
    fill: "#C8CDD3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1514 69.2598L28.1479 70.4785L25.1172 70.4925L25.1207 69.2736L28.1514 69.2598Z",
    fill: "#C8CDD3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1623 70.9951L31.1588 72.214L28.1328 72.2306L28.1363 71.0117L31.1623 70.9951Z",
    fill: "#C8CDD3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.168 72.7324L34.1645 73.9513L31.1387 73.9679L31.142 72.749L34.168 72.7324Z",
    fill: "#C8CDD3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9995 42.6064L91.9962 43.8252L37.1699 75.6868L37.1734 74.4678L91.9995 42.6064Z",
    fill: "#8993A0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M92.002 42.6062L37.1759 74.4676L34.1499 74.4841L34.1686 72.7314L31.1426 72.7479L31.1615 70.9952L28.1355 71.0117L28.1542 69.259L25.1235 69.2728L25.1471 67.5228L22.1162 67.5366L22.1398 65.7866L19.1091 65.8004L19.1325 64.0504L16.1018 64.064L16.1253 62.3142L13.0947 62.3278L13.118 60.5778L10.0874 60.5916L10.1061 58.8388L7.08008 58.8556L7.09896 57.1026L61.9251 25.2412L92.002 42.6062Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.174 74.4668L37.1705 75.6857L34.1445 75.7023L34.148 74.4833L37.174 74.4668Z",
    fill: "#C8CDD3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5749 42.493L61.7676 32.2121L62.9501 31.5293L80.7576 41.8104L79.5749 42.493Z",
    fill: "#AEB5BE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5008 43.6914L59.6934 33.4103L60.8759 32.7275L78.6834 43.0087L77.5008 43.6914Z",
    fill: "#AEB5BE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0767 42.3801L61.9629 37.1181L63.1454 36.4355L72.2592 41.6973L71.0767 42.3801Z",
    fill: "#AEB5BE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8813 66.3757L20.3965 52.2392L21.579 51.5566L46.064 65.6929L44.8813 66.3757Z",
    fill: "#AEB5BE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8071 67.5739L18.3223 53.4376L19.505 52.7549L43.9898 66.8912L42.8071 67.5739Z",
    fill: "#AEB5BE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7542 65.321L22.2227 58.0861L23.4054 57.4033L35.9367 64.6384L34.7542 65.321Z",
    fill: "#AEB5BE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0373 42.6719L49.7949 35.6037L50.9776 34.9209L63.2198 41.9891L62.0373 42.6719Z",
    fill: "#AEB5BE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9893 49.5725L70.2598 47.4191L71.4423 46.7363L75.1721 48.8897L73.9893 49.5725Z",
    fill: "#AEB5BE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7202 46.0601L46.7012 37.3888L47.8839 36.7061L62.9027 45.3771L61.7202 46.0601Z",
    fill: "#AEB5BE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8956 51.3585L68.6797 50.0792L69.8622 49.3965L72.0783 50.676L70.8956 51.3585Z",
    fill: "#AEB5BE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8518 46.244L43.6094 39.1757L44.7919 38.4932L57.0345 45.5612L55.8518 46.244Z",
    fill: "#AEB5BE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8042 53.1448L64.0742 50.9914L65.2569 50.3086L68.9867 52.462L67.8042 53.1448Z",
    fill: "#AEB5BE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3701 50.6922L40.5156 40.9611L41.6981 40.2783L58.5528 50.0093L57.3701 50.6922Z",
    fill: "#AEB5BE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7102 54.9297L60.9805 52.7765L62.1632 52.0938L65.893 54.2472L64.7102 54.9297Z",
    fill: "#AEB5BE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6662 49.8143L37.4238 42.746L38.6065 42.0635L50.8487 49.1315L49.6662 49.8143Z",
    fill: "#AEB5BE"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6182 56.7152L59.4023 55.4359L60.5849 54.7529L62.801 56.0324L61.6182 56.7152Z",
    fill: "#AEB5BE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3889 49.1861L34.3301 44.5333L35.5126 43.8506L43.5714 48.5034L42.3889 49.1861Z",
    fill: "#AEB5BE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5247 58.502L54.7949 56.3488L55.9776 55.666L59.7074 57.8194L58.5247 58.502Z",
    fill: "#AEB5BE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4768 53.3866L31.2344 46.3185L32.4169 45.6357L44.6595 52.7038L43.4768 53.3866Z",
    fill: "#AEB5BE"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M55.429 60.2873L51.6992 58.1341L52.8819 57.4512L56.6117 59.6046L55.429 60.2873Z",
    fill: "#AEB5BE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8 54.2588L28.1406 48.1046L29.3233 47.4219L39.9825 53.5761L38.8 54.2588Z",
    fill: "#AEB5BE"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3366 62.0732L46.373 58.63L47.5556 57.9473L53.5192 61.3905L52.3366 62.0732Z",
    fill: "#AEB5BE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6075_30498",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25 8.75) rotate(66.1979) scale(99.7328)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonIdealInvoice);
export default __webpack_public_path__ + "static/media/non_ideal_invoice.a4acb27a63c1a54e4340091fe20fb67f.svg";
export { ForwardRef as ReactComponent };